<template>
    <div class="stat-card">
        <div class="stat-icon">
            <font-awesome-icon :icon="iconType" />
        </div>
        <div class="stat-body">
            <p class="stat-label">{{ title }}</p>
            <h5 class="stat-value" :class="{ 'text-success': showPercentage && isPositive, 'text-error': showPercentage && !isPositive }">
                {{ format(amount) }}
                <span v-if="showPercentage" class="stat-percentage">({{ formattedPercentage }}%)</span>
            </h5>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Summary-Box',
  props: {
    title: String,
    amount: [String, Number, Array, Object],
    percentage: [String, Number],
    iconType: String,
    type: String,
  },
  computed: {
    showPercentage() {
      return this.percentage !== null && this.percentage !== undefined && this.percentage !== '';
    },

    formattedPercentage() {
      return (Number(this.percentage) || 0).toFixed(2);
    },

    isPositive() {
      return (Number(this.amount) || 0) >= 0;
    },
  },
  methods: {
    formatDate(string) {
      const date = new Date(string);
      // Then specify how you want your dates to be formatted
      return new Intl.DateTimeFormat('default', {dateStyle: 'long'}).format(date);
    },
    formatPrice(string) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'INR'
      });
      return formatter.format(string);
    },

    formatPercentage(value) {
      // Convert the input to a number, defaulting to 0 if it's not valid
      value = Number(value) || 0;

      // Create a new Intl.NumberFormat instance for percentage formatting
      var formatter = new Intl.NumberFormat('en-US', {
          style: 'percent',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
      });

      // Format and return the value
      return formatter.format(value / 100);
    },

    format(value){
      switch(this.type) {
        case 'datetime': {
            value = this.formatDate(value);
            break;
        }
        case 'currency': {
          value = this.formatPrice(value);
          break;
        }
        case 'percent': {
          value = this.formatPercentage(value);
        }
      }
      return String(value || '');
    },
  },
}
</script>

<style scoped>
.stat-card {
    background: #fff;
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 20px 22px;
    display: flex;
    align-items: center;
    gap: 16px;
    height: 100%;
}

.stat-icon {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--primary-tint);
    color: var(--primary);
    font-size: 1.15rem;
}

.stat-body {
    min-width: 0;
}

.stat-label {
    margin: 0 0 4px;
    font-size: 0.82rem;
    color: var(--text-muted);
    font-weight: 500;
}

.stat-value {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 700;
    color: var(--dark);
}

.stat-percentage {
    font-size: 0.85rem;
    font-weight: 500;
}
</style>
